import ContentWrapper from "@/components/Core/ContentWrapper";
import IconRenderer from "@/components/Shared/IconRenderer";
import mq from "@/utils/mq";
import { render } from "storyblok-rich-text-react-renderer";
import styled, { css } from "styled-components";

const NumberedItemsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  ${mq.tablet(css`
    flex-direction: column;
  `)};
`;

const TitleWrapper = styled.div`
  max-width: 500px;
  flex: 1;
  @media (max-width: 1250px) {
    max-width: 366px;
  }
`;

const Title = styled.h2`
  color: #f7f8f8;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: var(--font-pp-neue);
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
`;

const Items = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 66px;
  grid-row-gap: 46px;
  flex: 1;
  svg {
    stroke-width: 2px;
  }
  ${mq.tablet(css`
    margin-top: 32px;
  `)};
  ${mq.mobile(css`
    grid-template-columns: 1fr;
    grid-row-gap: 32px;
  `)};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ItemNumberContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const ItemNumber = styled.div`
  color: #d0d6e0;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 2px;
`;

const ItemTitle = styled.h3`
  color: #d0d6e0;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
`;

const ItemContent = styled.div`
  color: #d0d6e0;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;

export default function NumberedItems({ title, items }: { title: string; items: any[] }) {
  return (
    <ContentWrapper transparent>
      <NumberedItemsWrapper>
        <TitleWrapper>
          <Title>{title}</Title>
        </TitleWrapper>
        <Items>
          {items.map((item, index) => (
            <Item key={index}>
              <ItemNumberContainer>
                {item.icon ? (
                  <IconRenderer icon={item.icon} color='#d0d6e0' size={24} />
                ) : (
                  <ItemNumber>{index + 1}</ItemNumber>
                )}
              </ItemNumberContainer>
              <ItemTitle>{item.title}</ItemTitle>
              <ItemContent>{render(item.description)}</ItemContent>
            </Item>
          ))}
        </Items>
      </NumberedItemsWrapper>
    </ContentWrapper>
  );
}
